import clientAuth from "../clientAuth";

export default {
  // get brands 
  b_index: () => clientAuth.get("brand/index"),
  // get fuel 
  f_index: () => clientAuth.get("fuel/index"),
  // get Driving 
  d_index: () => clientAuth.get("driving/index"),
  // get OutDoor 
  o_index: () => clientAuth.get("outdoor/index"),
  // get kitchen 
  k_index: () => clientAuth.get("kitchen/index"),
  // get Living sleeping 
  ls_index: () => clientAuth.get("living_sleeping/index"),
  // get Feature
  feature: () => clientAuth.get("feature/index"),
  // get Service
  service: () => clientAuth.get("service/index"),
  // get Accessory
  accessory: () => clientAuth.get("accessory/index"),
  // get Package
  package: () => clientAuth.get("package/index"),
  // get Location
  location_index: () => clientAuth.get("location/index"),
  //
  type_index: () => clientAuth.get("camperType/index"),

  sale_index: () => clientAuth.get("saleType/index"),

  index: () => clientAuth.get("camper/index"),
  //
  camperStore: (camperData) => clientAuth.post('camper/store', { json: camperData }),

  saleStore: (userData) => clientAuth.post('camperSale/store', { json: userData }),

  camperUpdate: (id, editData) => clientAuth.post(`camper/update/${id}`, { json: editData }),

  camper_show: (id) => clientAuth.get(`camper/show/${id}`),
  
  destroy: (id) => clientAuth.delete(`camper/destroy/${id}`),
  updateCamperstatus: (id) => clientAuth.post(`camper/updateCamperstatus/${id}`),
  updateCamperCalendar: (id) => clientAuth.post(`camper/updatecampercalendar/${id}`),
  license_plate_list: (id) => clientAuth.get(`camper/license-plates/${id}`)
};